// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AI6h8A3wQKXEHh {\n  margin: 16px 0 16px 40px;\n  position: relative;\n}\n._3EVvvvvBlHFjWb {\n  color: #172B4D;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  line-height: 20px;\n  margin-top: 24px;\n  position: relative;\n}\n._1FEwe_FTcvG7_G {\n  left: -40px;\n  position: absolute;\n  top: -2px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": "AI6h8A3wQKXEHh",
	"title": "_3EVvvvvBlHFjWb",
	"icon": "_1FEwe_FTcvG7_G"
};
export default ___CSS_LOADER_EXPORT___;
